const {jQuery: $} = window;
import Utils from "./utils.class";
import Trustarc from "./Trustarc.class";
import Cookies from 'js-cookie';
import ActiveCampaign from "./ActiveCampaign.class";

export default class Theme {
    $main;
    $html;
    $body;
    $header;
    #config;
    #scrollOffset;
    scrollSpeed;
    #activeCampaign;
    #trustarc;
    #utils;
    #$admin;
    #root;
    #isEditing = false;

    constructor(
        config,
        utils,
    ) {
        this.#config = config;
        this.#utils = utils;
        this.#scrollOffset = 0;
        this.#root = document.querySelector(":root");

        this.scrollSpeed = 750;
        this.$html = $('html');
        this.$body = $('body');
        this.$main = $('.ocm-effect-wrap');
        this.$header = $('header .header-outer');
        this.#$admin = $('#wpadminbar');

        if (window.location.hash === "#dev") {
            Cookies.set("debug", "1");
        }

        Utils.log("Theme Config:", config);

        this.#activeCampaign = new ActiveCampaign(config.activeCampaignHost, config.emailBannedDomains, config.emailFreeDomains, config.formAutosetValues);
        this.#trustarc = new Trustarc(this.$body);

        this.#trustarcIntegration();
    }

    __onReady() {
        const me = this;

        Utils.log("Theme Ready");

        $(window).on('hashchange', function (e) {
            Utils.log("Scroll to Section Ready");

            if (location.hash) {
                if (!Utils.scrollToHash(location.hash, null, me.scrollOffset + 100, me.scrollSpeed)) {
                    e.preventDefault();
                }
            }
        });

        // $(document).on('click', 'a', function (e) {
        //     let $el = $(this);
        //
        //     // Storylane integration
        //     if ($el.attr('href') && $el.attr('href').search('#tourFullscreen') === 0) {
        //         e.preventDefault();
        //         let parent = $el.closest(".builder-table");
        //         let iframe = parent.find("iframe");
        //         if (iframe[0]) {
        //             iframe[0].requestFullscreen();
        //         }
        //     }
        //
        //     if ($el.attr('href') && $el.attr('href').search('#') === 0) {
        //         let hash = $el[0].hash;
        //
        //         if (!Utils.scrollToHash(hash, null, me.scrollOffset + 100, me.scrollSpeed)) {
        //             e.preventDefault();
        //         }
        //     }
        // });
    }

    __onLoad() {
        const me = this;

        Utils.log("Theme Load");
        this.#$admin = $('#wpadminbar');

        if (location.hash) {
            Utils.log("Scroll to Section Load");

            setTimeout(function () {
                Utils.scrollToHash(location.hash, null, me.scrollOffset, me.scrollSpeed);

            }, 300);
        }

        // Enable mockup mode
        $(window).on("keydown", (e) => {
            if(e.ctrlKey && e.which === 77 && !this.#isEditing && $("#mockup-controls").length > 0) {
                this.EnableMockupMode(true);
            }
        });
    }

    __onResize() {
        this.#updateCssHeaderHeight();
    }

    __postFilters(api) {
        /**
         * Resolve a select2 conflict surfaced by the "resources" template.
         *
         * KMDG Post Filters registers its (modern) select2 under the generic "select2" handle, which collides
         * with the parent theme / page builder's older select2 build. On a Salient page that older build wins the
         * global $.fn.select2 and routes select2's `dropdownCssClass` / `selectionCssClass` options through a
         * compat module it doesn't ship — throwing "Uncaught Error: No select2/compat/dropdownCss".
         *
         * We don't need those css-class options: instead we render the dropdown inside the shortcode form
         * (dropdownParent) and rely on the in-form `.kpfsc--resources-template` scope for styling. Stripping them
         * lets select2 initialize cleanly against whichever build is active, keeping the widget fully functional.
         *
         * Registered during the plugin's `kpf:ready` event (fired before it initializes select2) and scoped by
         * data-template so other shortcodes/templates are untouched.
         */
        api.addFilter('select2_options', function (options, $select, $form) {
            let opts = $.extend({}, options);
            delete opts.dropdownCssClass;   // needs a compat module the winning select2 build lacks
            delete opts.selectionCssClass;  // same family of option; not needed here
            opts.dropdownParent = $form;    // keep the dropdown inside our scoped container for styling
            return opts;
        });
    }

    #trustarcIntegration() {
        const self = this;

        $(window).on(this.#trustarc.events.consent.functional, function event() {
            event.hasRun = event.hasRun || false;
            self.#trustarcFunctional(true, event.hasRun);
            event.hasRun = true;
        });

        $(window).on(this.#trustarc.events.consent.advertising, function event() {
            event.hasRun = event.hasRun || false;
            self.#trustarcAdvertising(true, event.hasRun);
            event.hasRun = true;
        });

        $(window).on(this.#trustarc.events.denied.functional, function event() {
            event.hasRun = event.hasRun || false;
            self.#trustarcFunctional(false, event.hasRun);
            event.hasRun = true;
        });

        $(window).on(this.#trustarc.events.denied.advertising, function event() {
            event.hasRun = event.hasRun || false;
            self.#trustarcAdvertising(false, event.hasRun);
            event.hasRun = true;
        });
    }

    #trustarcFunctional(consent, hasRun) {

        if (consent) {
            if (!hasRun) {
                if(this.#activeCampaign) {
                    this.#activeCampaign.load();
                }
            }
        } else {
            // No consent
        }
    }

    #trustarcAdvertising(consent, hasRun) {
        if (consent) {

        } else {
            // No consent
        }
    }

    EnableMockupMode(status) {
        const $page = $("#page");
        const $html = $("html");
        const $body = $("body");

        if(status) {
            if(!$body.hasClass('mockup-edited')){
                $page.data("original", $page.html());
            }
            $page.attr("contenteditable", true);
            $body.addClass("mockup-editing");
            this.#isEditing = true;
        } else {
            $page.attr("contenteditable", false);
            $body.removeClass("mockup-editing").addClass("mockup-edited");
            this.#isEditing = false;

            $.getScript(location.protocol + "//" + location.host + "/wp-content/themes/salient-child/dist/js/mockup.min.js", () => {
                $page.html(HtmlDiff.execute($page.data("original"), $page.html()));

                let changes = "";
                $("*:is(.diffdel, .diffmod, del.mod, ins.mod, .diffins)").not(":empty").each((i, el) => {
                    const id = Math.round(Math.random()*100000);

                    const temp = $(el).clone();
                    let inner = temp.html().trim();

                    if(inner === '') temp.html("(whitespace)");

                    $(el).attr("data-scroll", `el-${id}`)

                    changes += `<li><a href="#el-${id}">${temp[0].outerHTML}</a></li>`;
                });

                $("body").append(`<pre class='mockup-changelog'><ul style="margin:0">${changes}</ul></pre>`);

                const slug = themeSettings.page;
                const id = themeSettings.postID;
                const html = "<!DOCTYPE html>" + $html[0].outerHTML;
                const bl = new Blob([html], {type: "text/html"});
                const a = document.createElement("a");
                a.href = window.URL.createObjectURL(bl);
                a.download = `mockup--${slug}--${id}.html`;
                a.style.display = 'none';
                document.body.appendChild(a);
                a.innerHTML = "Save";
                a.click();
                window.URL.revokeObjectURL(url);
            });
        }
    }

    get utils() {
        return Utils;
    }

    get headerHeight() {
        if (this.#$admin.length > 0) {
            return this.$header.outerHeight() + this.#$admin.outerHeight();
        }

        return this.$header.outerHeight();
    }

    get scrollOffset() {
        let subNav = 0;

        return this.#scrollOffset + this.headerHeight + subNav;
    }

    #updateCssHeaderHeight() {
        this.#root.style.setProperty('--header-height', this.headerHeight + "px");
    }
}